import '/app/brewery-packages/content/content-editor-plugin-link/src/Link.css-raw';
export default {
  "link": "jobs-2ec46bc8-link-d8xOKa"
};